// extracted by mini-css-extract-plugin
export default {"body":"PatientInfoDialog_body__oYuDs"};